import { dropdownItems } from "../services/util.service";

export abstract class IndexdbRepository {

    abstract getDropdownItemByType(type: string): Promise<dropdownItems[]>
    abstract getAllItemByType(type: string): any[]

}